<template>
  <teleport to="body">
    <div v-if="idle" class="fixed inset-0 z-50 w-screen h-screen">
      <video
        src="videos/CPN_Escent Rayong3_Animation_211117.mp4"
        poster="videos/CPN_Escent Rayong3_Animation_211117.png"
        class="object-cover w-full h-full"
        autoplay
        loop
        muted
      />
    </div>
  </teleport>
</template>

<script>
import { ref } from 'vue'
import { useStore } from 'vuex'

export default {
  setup () {
    const idle = ref(false)

    const store = useStore()

    try {
      window.App.onSystemStateChange((state) => {
        idle.value = state === 'idle'
        store.commit('setSystemState', state)
      })

      console.info('[APP]', 'Screensaver is enabled.')
    } catch {
      console.info('[APP]', 'Screensaver is disabled.')
    }

    return { idle }
  },
}
</script>
